// extracted by mini-css-extract-plugin
export default {"Spacer":"Spacer-module__Spacer--hJZe7"};